module.exports = __webpack_public_path__ + "static/img/product04-4.8a90a0d7.png";